import { AavoMosaic } from "src/components/common/mosaic/AavoMosaic.tsx";
import { DeliveryForm, DeliveryFormProps } from "src/components/views/erp/delivery/delivery/DeliveryForm.tsx";
import { DeliveryPackagesDataGrid } from "../deliveryPackage/DeliveryPackagesDataGrid.tsx";
import i18n from "i18next";
import { useIsMobile } from "src/utils/breakpointUtils.ts";

export interface DeliveryFormWithPackagesProps {
	deliveryId: number;
	onFormCompleted: DeliveryFormProps["onCompleted"];
	onFormEdited?: DeliveryFormProps["onFormEdited"];
	readonly?: boolean;
}

export const DeliveryFormWithPackages = ({
	deliveryId,
	onFormCompleted,
	onFormEdited,
	readonly,
}: DeliveryFormWithPackagesProps) => {
	const isMobile = useIsMobile();

	const deliveryForm = (
		<DeliveryForm
			initialization={{
				type: "existingDelivery",
				deliveryId: deliveryId,
			}}
			onCompleted={onFormCompleted}
			onFormEdited={onFormEdited}
			readonly={readonly}
		/>
	);

	if (isMobile) return deliveryForm;

	return (
		<AavoMosaic
			viewId={"A01310EA80E99B3D"}
			layout={{
				type: "row",
				first: {
					type: "panel",
					title: i18n.t("delivery"),
					content: deliveryForm,
				},
				second: {
					type: "panel",
					title: i18n.t("delivery_packages"),
					content: (
						<DeliveryPackagesDataGrid
							gridId={"215795492EC3817C"}
							deliveryId={deliveryId}
							disablePagination
							readonly={readonly}
							addEnabled={!readonly}
							printPackageLabelButtonLocation={"actionBar"}
						/>
					),
				},
			}}
		/>
	);
};
